import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdmissionProcedureComponent } from './components/pages/admission-procedure/admission-procedure.component';
// import { ArtsComponent } from './components/pages/arts/arts.component';
import { AutismComponent } from './components/pages/autism/autism.component';
import { ContactUs } from './components/pages/contact/contact.component';
import { CulturalComponent } from './components/pages/cultural/cultural.component';
import { ECDP } from './components/pages/ecdp/ecdp.component';
import { EducationSystem } from './components/pages/education-system/education-system.component';
import { facilities } from './components/pages/facilities/facilities.component';
import { FuturePlanComponent } from './components/pages/future-plan/future-plan.component';
import { GoverningBody } from './components/pages/governing-body/governing-body.component';
import { HearingComponent } from './components/pages/hearing/hearing.component';
import { history } from './components/pages/history/history.component';
import { Home } from './components/pages/home/home.component';
import { IdComponent } from './components/pages/id/id.component';
import { MeeComponent } from './components/pages/mee/mee.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { NoticeComponent } from './components/pages/notice/notice.component';
import { NutritionComponent } from './components/pages/nutrition/nutrition.component';
import { OngoingProjectsComponent } from './components/pages/ongoing-projects/ongoing-projects.component';
import { OrgstrutureComponent } from './components/pages/orgstruture/orgstruture.component';
import { OT } from './components/pages/ot/ot.component';
// import { FolderListComponent } from './components/pages/photos/folder-list/folder-list.component';
// import { ImageListComponent } from './components/pages/photos/image-list/image-list.component';
import { PpsComponent } from './components/pages/pps/pps.component';
import { PsychologyComponent } from './components/pages/psychology/psychology.component';
import { PTS } from './components/pages/pts/pts.component';
import { SLT } from './components/pages/slt/SLT.component';
import { SportsComponent } from './components/pages/sports/sports.component';
import { TherapistComponent } from './components/pages/therapist/therapist.component';
import { VolunteerComponent } from './components/pages/volunteer/volunteer.component';
import { TeacherAssistantComponent } from './components/pages/teacherassistant/teacherassistant.component';

// import { VolunteerComponent } from './components/pages/volunteer/volunteer.component';
import { StaffsComponent } from './components/pages/staffs/staffs.component';
import { TeachersComponent } from './components/pages/teachers/teachers.component';
import { underConstruction } from './components/pages/underConstrction/underConstruction.component';
import { VideosComponent } from './components/pages/videos/videos.component';
import { VS } from './components/pages/vs/vs.component';
import { MessagesComponent } from './components/pages/messages/messages.component';
import { MessageOneComponent } from './components/pages/message-one/message-one.component';
import { MessageTwoComponent } from './components/pages/message-two/message-two.component';
import { VolunteerServiceComponent } from './components/pages/volunteer-service/volunteer-service.component';
import { MessageThreeComponent } from './components/pages/message-three/message-three.component';
import { MessageFourComponent } from './components/pages/message-four/message-four.component';
import { ItComponent } from './components/pages/it/it.component';
import { InclusionComponent } from './components/pages/inclusion/inclusion.component';
import { InclusionFrobelComponent } from './components/pages/inclusion-frobel/inclusion-frobel.component';
import { InclusionEisComponent } from './components/pages/inclusion-eis/inclusion-eis.component';
import { InlusionCgsComponent } from './components/pages/inlusion-cgs/inlusion-cgs.component';
import { EventsZooComponent } from './components/pages/events-zoo/events-zoo.component';
import { EventsUtshabComponent } from './components/pages/events-utshab/events-utshab.component';
import { EventsEuphoriaComponent } from './components/pages/events-euphoria/events-euphoria.component';
import { EventsBirthdayComponent } from './components/pages/events-birthday/events-birthday.component';
import { EventsPaitingComponent } from './components/pages/events-paiting/events-paiting.component';
import { EventsFatherComponent } from './components/pages/events-father/events-father.component';
import { EventsKamalComponent } from './components/pages/events-kamal/events-kamal.component';
import { EventsMldComponent } from './components/pages/events-mld/events-mld.component';
import { EventsSportsComponent } from './components/pages/events-sports/events-sports.component';
import { EventsOtComponent } from './components/pages/events-ot/events-ot.component';
import { EventsAcpComponent } from './components/pages/events-acp/events-acp.component';
import { EventsMadamComponent } from './components/pages/events-madam/events-madam.component';
import { EventsTapComponent } from './components/pages/events-tap/events-tap.component';
import { EventsUcepComponent } from './components/pages/events-ucep/events-ucep.component';
import{ AssistantComponent } from './components/pages/assistant/assistant.component';
import { JournalComponent } from './components/pages/Journal/journal';
import { TemplatePageComponent } from "./components/pages/template-page/template-page.component";
import { AdministrationComponent } from "./components/pages/administration/administration.component";
import { ImageGalleryComponent } from './components/pages/image-gallery/image-gallery.component';
import { ImageFolderComponent } from './components/pages/image-folder/image-folder.component';
import { VideoGalleryComponent } from './components/pages/video-gallery/video-gallery.component';
import { VideoFolderComponent } from './components/pages/video-folder/video-folder.component';
import { TemplateTwoComponent } from './components/pages/template-two/template-two.component';
import { NewAndEventsComponent } from './components/pages/new-and-events/new-and-events.component';
import { NewAndEventsItemsComponent } from './components/pages/new-and-events-items/new-and-events-items.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServicesItemComponent } from './components/pages/services-item/services-item.component';
import { InclusionItemComponent } from './components/pages/inclusion-item/inclusion-item.component';
import { ELibraryComponent } from './components/pages/e-library/e-library.component';
import { FolderListComponent } from './components/pages/photos/folder-list/folder-list.component';
import { ImageListComponent } from './components/pages/photos/image-list/image-list.component';
import { SpecialEducationComponent } from './components/pages/special-education/special-education.component';
import { StoryComponent } from './components/pages/story/story.component';
import { RhymesComponent } from './components/pages/rhymes/rhymes.component';
import { ScienceComponent } from './components/pages/science/science.component';
import { EducationComponent } from './components/pages/education/education.component';
import { IndependenceOfBangladeshComponent } from './components/pages/independence-of-bangladesh/independence-of-bangladesh.component';
import { MedicalScienceComponent } from './components/pages/medical-science/medical-science.component';
import { MathematicsComponent } from './components/pages/mathematics/mathematics.component';
import { EnglishComponent } from './components/pages/english/english.component';
import { EHistoryComponent } from './components/pages/e-history/e-history.component';
import { EPersonalityComponent } from './components/pages/e-personality/e-personality.component';
import { WomenAwakeningComponent } from './components/pages/women-awakening/women-awakening.component';
import { ESportsComponent } from './components/pages/e-sports/e-sports.component';
import { ArtsComponent } from './components/pages/arts/arts.component';
const routes: Routes = [
  { path: '', component: Home },
  
  { path: 'history', component: TemplateTwoComponent },

  { path: 'special-education', component: SpecialEducationComponent },
  { path: 'story', component: StoryComponent },
  { path: 'e-sports', component: ESportsComponent },
  { path: 'rhymes', component: RhymesComponent },
  { path: 'science', component: ScienceComponent },
  { path: 'education', component: EducationComponent },
  { path: 'independence-Of-bangladesh', component: IndependenceOfBangladeshComponent },
  { path: 'mathematic', component: MathematicsComponent },
  { path: 'english', component: EnglishComponent },
  { path: 'e-history', component: EHistoryComponent },
  { path: 'e-personality', component: EPersonalityComponent },
  { path: 'women-awakening', component: WomenAwakeningComponent },
  { path: 'medical-science', component: MedicalScienceComponent },
  { path: 'ongoing-projects', component: TemplatePageComponent},
 
  { path: 'organizational-structure', component: TemplatePageComponent },
  { path: 'es', component: TemplateTwoComponent },
  { path: 'library', component: TemplatePageComponent },
  { path: 'computerLab', component: TemplatePageComponent },
  { path: 'playGround', component: TemplatePageComponent },
  { path: 'canteen', component: TemplatePageComponent },
  { path: 'transport', component: TemplatePageComponent },
  { path: 'multipurposeShed', component: TemplatePageComponent },
  { path: 'inDoorGames', component: TemplatePageComponent },
  { path: 'tailorShop', component: TemplatePageComponent },
  { path: 'gardenAndNursery', component: TemplatePageComponent },
  { path: 'vegetableAndFishMarket', component: TemplatePageComponent },
  { path: 'fishAquarium', component: TemplatePageComponent },
  { path: 'modernClassroom', component: TemplatePageComponent },
  { path: 'others', component: TemplatePageComponent },
  { path: 'ongoing-projects', component: TemplatePageComponent },
  { path: 'future-plan', component: TemplatePageComponent },
  { path: 'gb', component: TemplatePageComponent },
  { path: 'messages', component: MessagesComponent },
  { path: 'teacher-information', component: TemplatePageComponent },
  { path: 'ot', component: TemplatePageComponent },
  { path: 'pts', component: TemplatePageComponent },
  { path: 'slt', component: TemplatePageComponent },
  { path: 'psychology', component: TemplatePageComponent },
  { path: 'nutrition', component: TemplatePageComponent },
  { path: 'ecdp', component: TemplatePageComponent },
  { path: 'vs', component: TemplatePageComponent },
  { path: 'pps', component: TemplatePageComponent },
  { path: 'autism', component: TemplatePageComponent },
  { path: 'hearing-section', component: TemplatePageComponent },
  { path: 'id', component: TemplatePageComponent },
  { path: 'sports', component: SportsComponent },
  { path: 'cultural', component: CulturalComponent },
  { path: 'it', component: ItComponent },
  { path: 'arts', component: ArtsComponent },
  { path: 'mee', component: MeeComponent },
  { path: 'ap', component: TemplatePageComponent }, 
  { path: 'notice', component: NoticeComponent },
  // { path: 'history', component: TemplatePageComponent },

  { path: 'education-system', component: TemplatePageComponent },
  { path: 'regulatory-body', component: TemplatePageComponent },
  { path: 'students-login', component: TemplatePageComponent },
  { path: 'teachers-login', component: TemplatePageComponent },
  { path: 'multipurpose-shed', component: TemplatePageComponent },
  { path: 'tailor-shop', component: TemplatePageComponent },
  { path: 'play-ground', component: TemplatePageComponent },
  { path: 'in-door-games', component: TemplatePageComponent },
  { path: 'garden-and-nursery', component: TemplatePageComponent },
  { path: 'vegetable-and-fish-market', component: TemplatePageComponent },
  { path: 'fish-aquarium', component: TemplatePageComponent },
  { path: 'modern-classroom', component: TemplatePageComponent },
  { path: 'therapeutic-support-service', component: TemplatePageComponent },
  { path: 'special-education-program', component: TemplatePageComponent },
  { path: 'early-childhood-development-program', component: TemplatePageComponent },
  { path: 'teachers', component: TeachersComponent },
  { path: 'vocational-section', component: TemplatePageComponent },
  { path: 'pre-primary-section', component: TemplatePageComponent },
  { path: 'autism-section', component: TemplatePageComponent },
  { path: 'hearing-section', component: TemplatePageComponent },
  { path: 'id-section', component: TemplatePageComponent },
  { path: 'schools', component: TemplatePageComponent },
  { path: 'notice-board', component: NoticeComponent },
  // { path: 'e-library', component: ELibraryComponent },

  // { path: 'pts', component: PTS },
  // { path: 'ot', component: OT },
  // { path: 'slt', component: SLT },
  // { path: 'vs', component: VS },
  // { path: 'gb', component: GoverningBody },
  // { path: 'es', component: EducationSystem },
  // { path: 'history', component: history },
  // { path: 'arts', component: ArtsComponent },
  // { path: 'mee', component: MeeComponent },
  // { path: 'sports', component: SportsComponent },
  // { path: 'ongoing-projects', component: OngoingProjectsComponent },
  // { path: 'notice', component: NoticeComponent },
  // { path: 'videos', component: VideosComponent },
  // { path: 'cultural', component: CulturalComponent },
  // { path: 'underConstruction', component: underConstruction },
  { path: 'contact', component: ContactUs },
  // { path: 'ap', component: AdmissionProcedureComponent },
   {path: 'therapist', component: TherapistComponent }, 
   {path: 'volunteer', component: VolunteerComponent }, 
   {path: 'education-assistant', component: AssistantComponent},
   {path: 'teacher-assistant', component: TeacherAssistantComponent},    
  { path: 'staffs', component: StaffsComponent },
  // { path: 'teachers', component: TeachersComponent },
  // { path: 'organizational-structure', component: OrgstrutureComponent },
  // { path: 'psychology', component: PsychologyComponent },
  // { path: 'nutrition', component: NutritionComponent },
  // { path: 'pps', component: PpsComponent },
  // { path: 'autism', component: AutismComponent },
  // { path: 'hearing-section', component: HearingComponent },
  // { path: 'id', component: IdComponent },
  // { path: 'future-plan', component: FuturePlanComponent },
  // { path: 'messages', component: MessagesComponent },
  // { path: 'messageOne', component: MessageOneComponent },
  // { path: 'messageTwo', component: MessageTwoComponent },
  // { path: 'messageThree', component: MessageThreeComponent },
  // { path: 'messageFour', component: MessageFourComponent },
  { path: 'volunteer-service', component: TemplatePageComponent },
  // { path: 'it', component: ItComponent },
  // { path: 'inclusion', component: InclusionComponent },
  // { path: 'inclusion-frobel', component: InclusionFrobelComponent },
  // { path: 'inclusion-eis', component: InclusionEisComponent },
  // { path: 'inclusion-cgs', component: InlusionCgsComponent },
  // { path: 'events-zoo', component: EventsZooComponent },
  // { path: 'events-utshab', component: EventsUtshabComponent },
  // { path: 'events-euphoria', component: EventsEuphoriaComponent },
  // { path: 'events-paiting', component: EventsPaitingComponent },
  // { path: 'events-father', component: EventsFatherComponent },
  // { path: 'events-kamal', component: EventsKamalComponent },
  // { path: 'events-mld', component: EventsMldComponent },
  // { path: 'events-sports', component: EventsSportsComponent },
  // { path: 'events-ot', component: EventsOtComponent },
  // { path: 'events-acp', component: EventsAcpComponent },
  // { path: 'events-birthday', component: EventsBirthdayComponent },
  // { path: 'events-madam', component: EventsMadamComponent },
  // { path: 'events-tap', component: EventsTapComponent },
  // { path: 'events-ucep', component: EventsUcepComponent },
  // { path: 'journal', component: JournalComponent },
  {
    path: "administration",
    children: [
      { path: "", component: AdministrationComponent },
      { path: ":item", component: AdministrationComponent },
    ],
  },
  {
    path: 'e-library',
    children: [
      { path: '', component: FolderListComponent },
      { path: ':folderId', component: ImageListComponent },
    ],
  },
  {
    path: 'facilities',
    children: [
      { path: '', component: facilities },
      { path: ':item', component: facilities },
    ],
  },
  { path: "photo-gallery", component: ImageGalleryComponent },
  { path: "video-gallery", component: VideoGalleryComponent },

  {
    path: "imageFolder",
    children: [
      { path: "", component: ImageFolderComponent },
      { path: ":folderId", component: ImageFolderComponent },
    ],
  },
  {
    path: "videoFolder",
    children: [
      { path: "", component: VideoFolderComponent },
      { path: ":folderId", component: VideoFolderComponent },
    ],
  },  
  {
    path: "news-and-events",
    children: [
      { path: "", component: NewAndEventsComponent },
      { path: ":ItemId", component: NewAndEventsItemsComponent },
    ],
  },
  {
    path: "inclusion",
    children: [
      { path: "", component: InclusionComponent },
      { path: ":ItemId", component: InclusionItemComponent },
    ],
  },
  {
    path: "services",
    children: [
      { path: "", component: ServicesComponent },
      { path: ":ItemId", component: ServicesItemComponent },
    ],
  },
  { path: '**', component: NotFoundComponent }, // This line will remain down from the whole pages component list
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
